<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from "@/helpers/helper";

import { useWalletStore } from "@/store/walletStore";
import { useAgentStore } from "@/store/agentStore";
import { useCountryStore } from "@/store/countryStore";
import { useCurrencyStore } from "@/store/currencyStore";
import { useAggregatorStore } from "@/store/aggregatorStore";
import { useMethodStore } from '@/store/methodStore'


import { ref } from "vue";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const walletStore = useWalletStore();
    const agentStore = useAgentStore();
    const countryStore = useCountryStore();
    const currencyStore = useCurrencyStore();
    const aggregatorStore = useAggregatorStore();
    const methodStore = useMethodStore();


    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      walletStore,
      agentStore,
      countryStore,
      currencyStore,
      aggregatorStore,
      methodStore,

    };
  },
  page: {
    title: "wallet",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "wallet",
      items: [
        {
          text: "Menu",
        },
        {
          text: "wallet",
          active: true,
        },
      ],
      errors: [],
      wallet: {},

      wallets: [],
      agents: [],
      managers: [],
      aggregators: [],
      countries: [],
      currencies: [],
      accountNumbers: [],
      methods: [],
      selectedAgentAccounts: [],
      selectedMethods: [],

      agent_id: "",
      currency_id: "",
      country_id: "",
      aggregator_id: "",
      account_id: "",
      parent_id: "",
      method_id: "",

      number: "",
      accountName: "",
      link: "",
      status: "",

      loading: false,
      statusHttp: 201,
    };
  },
  methods: {
    
    toDate(date) {
      return Helper.toDate(date);
    },

    async loadFromStore() {
      if (!this.walletStore.list) {
        await this.walletStore.loadFromApi(true).then((data) => {
          this.wallets = data;
          this.wallet_search = data;
        });
      } else {
        this.wallets = this.walletStore.list;
        this.wallet_search = this.wallets;
      }
    },

    async refresh() {
      await this.walletStore.loadFromApi(true).then((data) => {
        this.wallets = data;
        this.wallet_search = data;
      });
    },

    async loadCountry() {
      if (!this.countryStore.list) {
        await this.countryStore.loadFromApi(true).then((data) => {
          this.countries = data;
          this.country_search = data;
        });
      } else {
        this.countries = this.countryStore.list;
        this.country_search = this.countries;
      }
    },

    async loadAgent() {
      if (!this.agentStore.withAccounts) {
        await this.agentStore.loadWithAccount().then((data) => {
          this.agents = data;
          this.accountNumbers = this.agents.flatMap(
            (agent) => agent.user?.accountNumbers || []
          );
        });
      } else {
        this.agents = this.agentStore.withAccounts;
        this.accountNumbers = this.agents.flatMap(
          (agent) => agent.user?.accountNumbers || []
        );
      }
    },

    async loadCurrency() {
      if (!this.currencyStore.list) {
        await this.currencyStore.loadFromApi(true).then((data) => {
          this.currencies = data;
          this.currency_search = data;
        });
      } else {
        this.currencies = this.currencyStore.list;
        this.currency_search = this.currencies;
      }
    },

    async loadAggregators() {
      if (!this.aggregatorStore.list) {
        await this.aggregatorStore.loadFromApi(true).then((data) => {
          this.aggregators = data;
          this.aggregator_search = data;
        });
      } else {
        this.aggregators = this.aggregatorStore.list;
        this.aggregator_search = this.aggregators;
      }
    },

    async loadMethods() {
      if (!this.methodStore.methods) {
        await  this.methodStore.loadFromApi(true).then(data => {
          this.methods = data
        })
      } else {
        this.methods = this.methodStore.list
      }

    },

    addItem() {
      this.errors = [];
      let body = {
        number: this.number,
        accountName: this.accountName,
        link: this.link,
        status: this.status,
      };

      Object.keys(body).forEach((key) => {
        if (body[key] == "") {
          body[key] = undefined;
        }
      });

      if (this.aggregator_id !== "") {
        body["aggregator"] = { id: this.aggregator_id };
      }
      if (this.agent_id !== "") {
        body["agent"] = { id: this.agent_id };
      }
      if (this.country_id !== "") {
        body["country"] = { id: this.country_id };
      }
      if (this.currency_id !== "") {
        body["currency"] = { id: this.currency_id };
      }
      if (this.account_id !== "") {
        body["account"] = { id: this.account_id };
      }
      if (this.parent_id && this.parent_id !== "") {
        body["parent"] = { id: this.parent_id };
      }
      if (this.method_id && this.method_id !== "") {
        body["method"] = { id: this.method_id };
      }


      this.walletStore.createItem(body);
      this.wallets = this.walletStore.list;
      this.wallet_search = this.wallets;
    },

    editItem() {
      this.errors = [];
      let body = {
        number: this.number,
        accountName: this.accountName,
        link: this.link,
        status: this.status,
      };

      Object.keys(body).forEach((key) => {
        if (body[key] == "") {
          body[key] = undefined;
        }
      });

      if (this.aggregator_id && this.aggregator_id !== "") {
        body["aggregator"] = { id: this.aggregator_id };
      }
      if (this.agent_id && this.agent_id !== "") {
        body["agent"] = { id: this.agent_id };
      }
      if (this.country_id && this.country_id !== "") {
        body["country"] = { id: this.country_id };
      }
      if (this.currency_id && this.currency_id !== "") {
        body["currency"] = { id: this.currency_id };
      }
      if (this.account_id && this.account_id != "") {
        body["account"] = { id: this.account_id };
      }
      if (this.parent_id && this.parent_id !== "") {
        body["parent"] = { id: this.parent_id };
      }
      if (this.method_id && this.method_id !== "") {
        body["method"] = { id: this.method_id };
      }





      this.walletStore.editItem(this.wallet.id, body);
      this.wallets = this.walletStore.list;
      this.wallet_search = this.wallets;
    },

    deleteIt() {
      this.walletStore.deleteItem(this.wallet.id);
      this.wallets = this.walletStore.list;
      this.wallet_search = this.wallets;
    },

    async onAddItem() {
      Swal.showLoading(null);
      await Promise.all([
        this.loadAggregators(),
        this.loadCountry(),
        this.loadCurrency(),
        this.loadAgent(),
        this.loadMethods()
      ]);
      Swal.close();
      this.doesAddOpen = true;
    },

    async initItem(wallet, action = "edit") {
      this.wallet = wallet;
      if (action == "delete") {
        this.doesDeleteOpen = true;

      } else {
        await Promise.all([
          this.loadAggregators(),
          this.loadCountry(),
          this.loadCurrency(),
          this.loadAgent(),
          this.loadMethods()
        ]);
        this.initData(wallet);
        this.doesEditOpen = true;
      }
    },

    initData(item = null) {
      this.status = item != null ? item.status : "";
      this.link = item != null ? item.link : "";
      this.accountName = item != null ? item.accountName : "";
      this.number = item != null ? item.number : "";
      this.currency_id = item != null ? item?.idOfCurrency : "";
      this.country_id = item != null ? item?.idOfCountry : "";
      this.agent_id = item != null ? item.idOfAgent : "";
      this.method_id = item != null ? item.idOfMethod : "";
      this.account_id = item != null ?( item.idOfAccount??item.account?.id ?? '') : "";
      this.aggregator_id = item != null ? item?.idOfAggregator : "";
      this.parent_id = item != null ? item?.idOfParent : "";

      if (this.agent_id) {
        this.updateAccounts();
      }
    },

    updateAccounts() {
      const selectedAgent = this.agents.find((agent) => agent.id === this.agent_id);
      this.selectedAgentAccounts = selectedAgent
        ? selectedAgent?.user?.accountNumbers
        : this.accountNumbers;
    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },
  },

  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },

  computed: {
    filterMethods() {
      let list = this.methods;
      list = list.filter(ele => !this.currency_id || ele.idOfCurrency == this.currency_id);
      list = list.filter(ele => !this.country_id || ele.idOfCountry == this.country_id);
      return list;
    }
  },
 
  watch: {
    doesAddOpen: async function () {
      this.errors = [];
      if (!this.doesAddOpen) {
        this.initData(null);
      }
    },
    doesEditOpen: async function () {
      this.errors = [];
      if (!this.doesEditOpen) {
        this.initData(null);
        this.wallet = null;
      }
    },
    doesDeleteOpen: function () {
      if (!this.doesDeleteOpen) {
        this.initData(null);
        this.wallet = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class="bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
      <b-button variant="primary" @click="onAddItem()" class="ms-1">
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        Ajouter un nouveau
      </b-button>
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des wallets</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>wallets</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <!-- <th>Method From</th>
                    <th>Method To</th> -->

                    <th>Name</th>
                    <th>Number</th>
                    <th>Agg</th>
                    <th>CC</th>
                    <th>CT</th>
                    <th>Method</th>
                    <th>Balance</th>
                    <th>Capital</th>
                    <th>fees</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(wallet, i) in wallets" :key="wallet.id">
                    <th scope="row" v-on:click="compileToClipboard(wallet.id)"
                    style="cursor: pointer" >{{ i + 1 }}</th>
                    <!-- <td>{{ wallet?.from?.name }}</td>
                    <td>{{ wallet?.to?.name }}</td>  -->

                    <td>{{ wallet.accountName }}</td>

                    <td v-b-tooltip.hover :title="wallet.link" variant="outline-secondary">{{ wallet.number }}</td>
                    <td>{{ wallet.aggregator?.name }}</td>
                    <td>{{ wallet.currency?.isoCode }}</td>
                    <td>{{ wallet.country?.isoCode }}</td>
                    <td>{{ wallet.method?.name ?? wallet.method?.name_en }}</td>
                    <td>{{ Number(wallet?.balance) }} </td>
                    <td>{{ Number(wallet?.capital) }}</td>
                    <td>{{ Number(wallet.fees) }}</td>
                    <td class="hstack">
                      <b-button class="btn-sm ms-2" @click="initItem(wallet, 'edit')" variant="success">
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <b-button variant="danger" @click="initItem(wallet, 'delete')" class="ms-2 btn-sm">
                        <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <router-link :to="'/wallets/' + wallet.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..." title-class="font-18"
      hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal v-model="doesAddOpen" id="modal-center" centered size="lg" title="Ajouter un wallet" title-class="font-18"
      hide-footer>
      <form @submit.prevent="addItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Currency</label>
            <select v-model="currency_id" class="form-control">
              <option value=""></option>
              <template v-for="currency in currencies" :key="currency.id">
                <option :value="currency.id">
                  {{ currency.name ?? currency.name_en }}({{ currency?.isoCode }})
                </option>
              </template>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Country</label>
            <select v-model="country_id" class="form-control">
              <option value=""></option>
              <template v-for="country in countries" :key="country.id">
                <option :value="country.id">
                  {{ country.name ?? country.name_en ?? country.name_fr }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Aggregator</label>
            <select v-model="aggregator_id" class="form-control">
              <option value=""></option>
              <template v-for="aggregator in aggregators" :key="aggregator.id">
                <option :value="aggregator.id">
                  {{ aggregator?.name ?? aggregator?.name_en }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Method</label>
            <select v-model="method_id" class="form-control">
              <option value=""></option>
              <template v-for="method in filterMethods" :key="method.id">
                <option :value="method.id">
                  {{ method?.name ?? method?.name_en }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Agent</label>
            <select v-model="agent_id" @change="updateAccounts()" class="form-control">
              <option value=""></option>
              <template v-for="agent in agents" :key="agent.id">
                <option :value="agent.id">
                  {{
                  agent?.user?.name ??
                  agent?.user?.firstName + " " + agent?.user?.lastName
                  }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez le compte</label>
            <select  v-model="account_id" active="" class="form-control">
              <option value=""></option>
              <option v-for="compte in selectedAgentAccounts" :key="compte.id" :value="compte.id">
                {{ compte.number }}({{ compte.method?.name }})
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Number</label>
            <input type="text" v-model="number" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Account Name</label>
            <input type="text" v-model="accountName" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Link</label>
            <input type="text" v-model="link" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status </label>
            <select class="form-control" required v-model="status">
              <option value="pending">pending</option>
              <option value="active">active</option>
              <option value="exceeded">exceeded</option>
              <option value="blocked">blocked</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.account_status">{{
              errors.account_status
              }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Parent ID</label>
            <input type="text" v-model="parent_id" class="form-control" />
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- EDIT MODAL -->
    <b-modal v-model="doesEditOpen" id="modal-center" centered size="lg" title="Modifier un wallet"
      title-class="font-18" hide-footer>
      <form @submit.prevent="editItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Currency</label>
            <select v-model="currency_id" class="form-control">
              <option value=""></option>
              <template v-for="currency in currencies" :key="currency.id">
                <option :value="currency.id">
                  {{ currency.name ?? currency.name_en }}({{ currency?.isoCode }})
                </option>
              </template>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Country</label>
            <select v-model="country_id" class="form-control">
              <option value=""></option>
              <template v-for="country in countries" :key="country.id">
                <option :value="country.id">
                  {{ country.name ?? country.name_en ?? country.name_fr }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Aggregator</label>
            <select v-model="aggregator_id" class="form-control">
              <option value=""></option>
              <template v-for="aggregator in aggregators" :key="aggregator.id">
                <option :value="aggregator.id">
                  {{ aggregator?.name ?? aggregator?.name_en }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Method</label>
            <select v-model="method_id" class="form-control">
              <option value=""></option>
              <template v-for="method in filterMethods" :key="method.id">
                <option :value="method.id">
                  {{ method?.name ?? method?.name_en }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Agent</label>
            <select v-model="agent_id" @change="updateAccounts()" class="form-control">
              <option value=""></option>
              <template v-for="agent in agents" :key="agent.id">
                <option :value="agent.id">
                  {{
                  agent?.user?.name ??
                  agent?.user?.firstName + " " + agent?.user?.lastName
                  }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez le compte</label>
            <select v-model="account_id" active="" class="form-control">
              <option value=""></option>
              <option v-for="compte in selectedAgentAccounts" :key="compte.id" :value="compte.id">
                {{ compte.number }}({{ compte.method?.name }})
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Number</label>
            <input type="text" v-model="number" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Account Name</label>
            <input type="text" v-model="accountName" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Link</label>
            <input type="text" v-model="link" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status </label>
            <select class="form-control" required v-model="status">
              <option value="pending">pending</option>
              <option value="active">active</option>
              <option value="exceeded">exceeded</option>
              <option value="blocked">blocked</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.account_status">{{
              errors.account_status
              }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Parent ID</label>
            <input type="text" v-model="parent_id" class="form-control" />
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal v-model="doesDeleteOpen" id="modal-center" title="Supprimer un wallet" title-class="font-18" hide-footer>
      <p class="mb-2">
        Voulez-vous vraiment supprimer le wallet
        <b>{{ wallet?.from?.name }} - {{ wallet?.to?.name }}</b> ?
      </p>
      <div class="hstack mt-2" v-if="!loading">
        <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">
          Annuler
        </button>
        <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
      </div>
      <div class="text-center" v-else>
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
